import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print3',
  templateUrl: './print3.component.html',
  styleUrls: ['./print3.component.scss']
})
export class Print3Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
